<template>
  <div class="help-desk-area ptb-100">
    <div class="container">
      <div class="section-title text-center">
        <span class="sub-title">Por Que Escolher a Fontes Business</span>
        <h2>Desenvolvemos soluções que transformam negócios</h2>
        <p>Combinamos expertise técnica, metodologia ágil e tecnologia de ponta para entregar resultados excepcionais</p>
      </div>

      <div class="benefits-grid">
        <div
            v-for="(benefit, index) in benefits"
            :key="benefit.id"
            class="benefit-card"
            data-aos="fade-up"
            :data-aos-delay="index * 100"
        >
          <div class="benefit-icon" :class="benefit.colorClass">
            <i :class="benefit.icon"></i>
          </div>
          <h3>{{ benefit.title }}</h3>
          <p>{{ benefit.description }}</p>
          <div class="benefit-features">
            <span
                v-for="(feature, idx) in benefit.features"
                :key="idx"
                class="feature-tag"
            >
              {{ feature }}
            </span>
          </div>
        </div>
      </div>

      <!-- Stats Bar -->
      <div class="stats-bar" data-aos="fade-up">
        <div class="stat-item">
          <i class="ph-rocket-launch"></i>
          <div>
            <strong>150+</strong>
            <span>Projetos Entregues</span>
          </div>
        </div>
        <div class="stat-item">
          <i class="ph-clock"></i>
          <div>
            <strong>24/7</strong>
            <span>Suporte Disponível</span>
          </div>
        </div>
        <div class="stat-item">
          <i class="ph-shield-check"></i>
          <div>
            <strong>98%</strong>
            <span>Satisfação</span>
          </div>
        </div>
        <div class="stat-item">
          <i class="ph-trophy"></i>
          <div>
            <strong>5+ Anos</strong>
            <span>No Mercado</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpDesk',
  data() {
    return {
      benefits: [
        {
          id: 1,
          icon: 'ph-lightning',
          colorClass: 'purple',
          title: 'Desenvolvimento Ágil',
          description: 'Metodologia ágil com entregas rápidas, transparência total e feedback contínuo durante todo o processo.',
          features: ['Scrum', 'Sprints Semanais', 'Daily Meetings']
        },
        {
          id: 2,
          icon: 'ph-code',
          colorClass: 'blue',
          title: 'Código Limpo',
          description: 'Melhores práticas de desenvolvimento com código seguro, escalável e de fácil manutenção.',
          features: ['Clean Code', 'SOLID', 'Code Review']
        },
        {
          id: 3,
          icon: 'ph-headset',
          colorClass: 'green',
          title: 'Suporte Contínuo',
          description: 'Suporte técnico especializado e manutenção contínua para garantir funcionamento perfeito.',
          features: ['24/7', 'SLA Garantido', 'Monitoramento']
        },
        {
          id: 4,
          icon: 'ph-rocket',
          colorClass: 'orange',
          title: 'Tecnologia Moderna',
          description: 'Tecnologias atuais e frameworks modernos para criar soluções inovadoras e competitivas.',
          features: ['React', 'Vue', 'Node.js', 'Python']
        }
      ]
    }
  }
}
</script>

<style scoped>
/* ===== AREA BASE ===== */
.help-desk-area {
  background: linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%);
}

/* ===== GRID DE BENEFÍCIOS ===== */
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin: 60px 0;
}

.benefit-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.benefit-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #6D5DFC 0%, #4361EE 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.benefit-card:hover::before {
  transform: scaleX(1);
}

.benefit-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  border-color: #6D5DFC;
}

/* ===== ÍCONES ===== */
.benefit-icon {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  transition: all 0.4s ease;
}

.benefit-icon i {
  font-size: 40px;
  color: white;
}

.benefit-icon.purple {
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
}

.benefit-icon.blue {
  background: linear-gradient(135deg, #4361EE 0%, #3B82F6 100%);
}

.benefit-icon.green {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
}

.benefit-icon.orange {
  background: linear-gradient(135deg, #F59E0B 0%, #EF4444 100%);
}

.benefit-card:hover .benefit-icon {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 10px 30px rgba(109, 93, 252, 0.3);
}

/* ===== CONTEÚDO ===== */
.benefit-card h3 {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
  transition: color 0.3s ease;
}

.benefit-card:hover h3 {
  color: #6D5DFC;
}

.benefit-card p {
  font-size: 15px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
}

/* ===== FEATURE TAGS ===== */
.benefit-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.feature-tag {
  display: inline-block;
  padding: 6px 14px;
  background: rgba(109, 93, 252, 0.1);
  border: 1px solid rgba(109, 93, 252, 0.2);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #6D5DFC;
  transition: all 0.3s ease;
}

.benefit-card:hover .feature-tag {
  background: rgba(109, 93, 252, 0.15);
  border-color: #6D5DFC;
}

/* ===== STATS BAR ===== */
.stats-bar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  padding: 40px 30px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(109, 93, 252, 0.3);
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 15px;
  color: white;
  padding: 10px;
}

.stat-item i {
  font-size: 36px;
  color: rgba(255, 255, 255, 0.9);
  flex-shrink: 0;
}

.stat-item div {
  display: flex;
  flex-direction: column;
}

.stat-item strong {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 5px;
}

.stat-item span {
  font-size: 13px;
  opacity: 0.9;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 991px) {
  .benefits-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .benefit-card {
    padding: 30px 25px;
  }

  .stats-bar {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .stats-bar {
    grid-template-columns: 1fr;
  }

  .stat-item {
    justify-content: center;
    text-align: center;
  }
}
</style>